import React, { useEffect, useState } from "react";
import { httpDeleteGroup } from "./api/calls";
import AddGroupModal from "./AddGroupModal";
import Pagination from "../subSkills/Pagination"
import {
  getGroups,
  getSkills,
} from "../../../../Redux/Actions/skill_matrix_actions";
import { useDispatch, useSelector } from "react-redux";
import SearchComponent from "./SearchComponent";
const Table = () => {
  const dispatch = useDispatch();
  const { departments, groups, searchByDeptName, searchByDeptId } = useSelector(
    (state) => state.skillMatrix
  );
  const [selectedGroup, setSelectedGroup] = useState(null);

  const handleUpdate = (group) => {
    setSelectedGroup(group);
  };

  const handleDelete = async (id) => {
    await httpDeleteGroup(id).then((res) => {
      if (res.status) {
        dispatch(getSkills());
        dispatch(getGroups());
        return alert(res.msg);
      } else {
        return alert(res.msg);
      }
    });
  };

  const getDepartmentName = (id) => {
    return departments?.find((dept) => dept.id === +id)?.name;
  };

  const [filteredGroups, setFilteredGroups] = useState(null);

  useEffect(() => {
    if (groups && searchByDeptName) {
      const filteredValues = groups.filter((ele) =>
        ele.name.toLowerCase().includes(searchByDeptName?.toLowerCase())
      );
      setFilteredGroups(filteredValues);
    }
    if (groups && searchByDeptId) {
      const filteredValues = groups.filter(
        (ele) => ele.dept_id == searchByDeptId
      );
      setFilteredGroups(filteredValues);
    }
    if (!searchByDeptName && !searchByDeptId) {
      setFilteredGroups(groups);
    }
  }, [searchByDeptName, searchByDeptId, groups]);




  
  const [currentPage, setCurrentPage] = useState(1);
  const postPerPage = 10;
  const totalPosts = filteredGroups?.length;


  const indexOfLastPost = currentPage * postPerPage;
  const indexOfFirstPost = indexOfLastPost - postPerPage;
  const filterGroupLists = filteredGroups?.slice(indexOfFirstPost, indexOfLastPost);
  return (
    <>
      <AddGroupModal
        group={selectedGroup}
        setSelectedGroup={setSelectedGroup}
      />

      <div className="row_bg">
        <SearchComponent />
        <div className="mb-4 wp100">
          <table className="table_style_1">
            <thead>
              <tr>
                <th style={{ width: "80px" }}>S.No</th>
                <th>Skill Name</th>
                <th>Skill Code</th>
                <th>Division</th>
                <th style={{ width: "180px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filterGroupLists &&
                filterGroupLists.map((group, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{group.name}</td>
                      <td>{group.code}</td>
                      <td>{getDepartmentName(group.dept_id)}</td>
                      <td>
                        <button
                          className="btn_7 mr03"
                          onClick={() => handleUpdate(group)}
                          data-bs-toggle="modal"
                          data-bs-target="#addgroup"
                        >
                          Edit
                        </button>
                        <button
                          className="btn_8"
                          onClick={() => handleDelete(group.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
            {filterGroupLists?.length > 0 &&
              <tfoot>
                <tr>
                  <td colSpan={5}>
                    {totalPosts > postPerPage && (
                      <Pagination
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPosts={totalPosts}
                        postPerPage={postPerPage}
                      />
                    )}
                  </td>
                </tr>
              </tfoot>
            }
          </table>
        </div>
      </div>
    </>
  );
};

export default Table;
